import { render, staticRenderFns } from "./PublishPermissions.vue?vue&type=template&id=0302d26c&scoped=true"
import script from "./PublishPermissions.vue?vue&type=script&lang=js"
export * from "./PublishPermissions.vue?vue&type=script&lang=js"
import style0 from "./PublishPermissions.vue?vue&type=style&index=0&id=0302d26c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0302d26c",
  null
  
)

export default component.exports